import { VaroCategories } from 'shared/analytics/types/categories';
import { ButtonComponentAnalytics } from 'shared/analytics/types/componentEvents';
import { VaroPressableName } from 'shared/analytics/types/pressableNames';
import { VaroSubCategories } from 'shared/analytics/types/subCategories';

export const getDcfButtonAnalytics = ({
  pressableName,
  isBelieveDay0Flow,
}: {
  pressableName: VaroPressableName;
  isBelieveDay0Flow: boolean;
}): ButtonComponentAnalytics => ({
  pressableName,
  category: VaroCategories.DCF,
  subCategory: isBelieveDay0Flow
    ? VaroSubCategories.DCF.DCF_BELIEVE_DAY_0_APPLICATION
    : VaroSubCategories.DCF.DCF,
});
